import { z } from "zod";

const processSurveyData = (completeSurveyObj, surveyCallBackFn) => {
	const dataKeys = Object.keys(completeSurveyObj);

	const responses = dataKeys
		.filter((key) => !key.includes("other"))
		.flatMap((eachDataKey) => {
			const userResponse = completeSurveyObj[eachDataKey];
			const quizId = eachDataKey.split("_")[1];
			const isArray = Array.isArray(userResponse);
			if (isArray) {
				return userResponse.map((eachResponse) => {
					const otherKey = `${eachDataKey}_other_${eachResponse}`;
					const hasOtherText = completeSurveyObj[otherKey];
					return {
						quiz_id: Number(quizId),
						option_id: Number(eachResponse),
						text_response: Boolean(hasOtherText)
							? hasOtherText
							: "NULL",
					};
				});
			} else {
				const otherKey = `${eachDataKey}_other_${userResponse}`;
				const hasOtherText = completeSurveyObj[otherKey];
				return {
					quiz_id: Number(quizId),
					option_id: Number(userResponse),
					text_response: Boolean(hasOtherText)
						? hasOtherText
						: "NULL",
				};
			}
		});
	return surveyCallBackFn(responses);
};

const base64ToFile = (base64, filename) => {
	const arr = base64.split(",");
	const mimeType = arr[0].match(/:(.*?);/)?.[1] || "image/jpeg";
	const binaryString = atob(arr[1]);

	let n = binaryString.length;
	const u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = binaryString.charCodeAt(n);
	}
	return new File([u8arr], filename, { type: mimeType });
};

const generateQuizSchema = (quizzes, hiddenQuizzesRef) => {
	const baseShape = {};
	const multiSelectSchema = z.object({
		option_id: z.number().optional().nullable(),
		option_text: z.string().optional(),
		text_response: z.string().optional(),
	});

	const hiddenIds = new Set(hiddenQuizzesRef.current || []);

	for (const quiz of quizzes) {
		const fieldKey = String(quiz.quiz_id);

		if (hiddenIds.has(quiz.quiz_id)) {
			if (
				quiz.quiz_type === "SINGLE_SELECT" ||
				quiz.quiz_type === "PLAIN_TEXT"
			) {
				baseShape[fieldKey] = z.string().optional();
			}

			if (quiz.quiz_type === "MULTIPLE_SELECT") {
				baseShape[fieldKey] = z.array(multiSelectSchema).optional();
			}
		} else {
			if (
				quiz.quiz_type === "SINGLE_SELECT" ||
				quiz.quiz_type === "PLAIN_TEXT"
			) {
				baseShape[fieldKey] = z
					.string()
					.nonempty("this question is required");
			}

			if (quiz.quiz_type === "MULTIPLE_SELECT") {
				baseShape[fieldKey] = z
					.array(multiSelectSchema)
					.min(1, "select at least one option");
			}
		}
	}

	const schema = z.object(baseShape);

	return schema;
};

const conditionalQuizzes = (quizzes = []) => {
	const conditionalQuizIds = [];

	for (const quiz of quizzes) {
		for (const option of quiz.options) {
			if (option.next_question_id)
				conditionalQuizIds.push(option.next_question_id);
		}
	}

	return [...new Set(conditionalQuizIds)];
};

const transformUserResponse = (
	userResponseObj,
	otherQuizText,
	responseCallBackFn
) => {
	const dataKeys = Object.keys(userResponseObj);
	const transformedResponse = dataKeys
		.filter((dataKey) => userResponseObj[dataKey])
		.flatMap((dataKey) => {
			const userResponse = userResponseObj[dataKey];
			const isArray = Array.isArray(userResponse);
            console.log({ blahhh: userResponse, otherQuizText });

			if (isArray) {
				return userResponse.map((eachResponse) => {
					return {
						quiz_id: Number(dataKey),
						option_id: Number(eachResponse?.option_id),
						text_response: Boolean(eachResponse?.text_response)
							? eachResponse?.text_response
							: "NULL",
					};
				});
			} else {
				return {
					quiz_id: Number(dataKey),
					option_id: isNaN(userResponse)
						? Number(dataKey)
						: Number(userResponse),
					text_response: Number.isNaN(userResponse)
						? userResponse.replace("#dob#", "")
						: Number(dataKey) ===
						  otherQuizText?.[Number(dataKey)]?.id
						? otherQuizText?.[Number(dataKey)]?.text
						: "NULL",
				};
			}
		});
	return responseCallBackFn(transformedResponse);
};

const getExpectedSections = (gender) => {
	return gender === "Female"
		? [1, 2, 3, 4, 5, 6, 7, 8] // females include section 5
		: [1, 2, 3, 4, 6, 7, 8]; // males skip section 5
};

const getNextSectionId_ = (sectionHistories, gender) => {
	const completed = sectionHistories.map((sectionId) => sectionId);
	const expected = getExpectedSections(gender);

	// Find first section that is missing
	for (const sectionId of expected) {
		if (!completed.includes(sectionId)) {
			return sectionId;
		}
	}

	// console.log({ expected , completed});

	// If none are missing, continue from last
	return expected[expected.length - 1];
};

export const getPendingSections = (
	allSections,
	sectionHistory,
	skipSections,
	shouldSkip = false
) => {
	let pending = allSections?.filter(
		(sectionId) => !sectionHistory?.includes(sectionId)
	);

	if (shouldSkip && skipSections?.length > 0) {
		pending = pending?.filter(
			(sectionId) => !skipSections?.includes(sectionId)
		);
	}

    if (pending?.length === 0) {
		// window.location.href = "/thank-you";
        console.log("section completed")
		return;
	}

	return pending?.sort((a, b) => a - b);
};

const getNextSectionId = (
	allSections,
	sectionHistory,
	skipSections,
	shouldSkip
) => {
	const pending = getPendingSections(
		allSections,
		sectionHistory,
		skipSections,
		shouldSkip
	);

    return pending.shift();

    //  return pending.length > 0 ? pending[0] : null
};

export {
	processSurveyData,
	base64ToFile,
	generateQuizSchema,
	getExpectedSections,
	getNextSectionId,
	conditionalQuizzes,
	transformUserResponse,
};
